import { isEmpty, isObject } from 'lodash'
import Cookies from 'js-cookie'
import store from '@/store'

/**
 * 返回全局变量
 */
export function globalVar() {
  const contact = store?.state?.system?.platformConfig?.contact || {}
  return {
    phone: contact?.consumerHotline || '400-8566-100',
    qqLink:
      contact?.qqLink || 'tencent://message/?uin=811028657&Site=&Menu=yes',
    email: contact?.consumerEmail || 'kefu@jczh.com',
    workTime: contact?.workTime || '08:30-12:00 14:00-17:30'
  }
}

/**
 * 返回OSS资源的完整路径
 * @param ossPath {string} 不带域名的资源链接
 */
export function getOSSUrl(ossPath) {
  if (!ossPath) return

  return `${process.env.VUE_APP_OSS_URL}/${ossPath}`
}

/**
 * 跳转至登录平台
 */
export function toLogin() {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null

  store.dispatch('system/toPlatform', {
    platform: 'login',
    query: { returnUrl: encodeURIComponent(window.location.href) },
    target: '_self'
  })
}

/**
 * 跳转至会员购买页
 */
export function toVipBuy(router) {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null

  router.push({
    name: 'VipBuy'
  })
}

/**
 * 跳转标书预览购买页面
 */
export function toBidFilePreviewBuy(data) {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null
  const extraStr = toStringOnPath(data || {})
  const url = `${process.env.VUE_APP_PORTAL_URL}
  /value-added/bid-file-preview/buy${extraStr ? `?${extraStr}` : ''}`
  window.open(addQueryToUrl(url), '_blank')
}

/**
 * 跳转至云采购门户公告页
 */
export function toPortalNotice({ noticeId = '', noticeUrl = '' }) {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null
  store.dispatch('system/toPlatform', {
    platform: 'portal',
    path: `/notice/${noticeId}`,
    url: noticeUrl
  })
}

/**
 * 跳转到支付中心
 * @param {string} payCode 支付订单号
 */
export function toPayCenter(payCode) {
  // 跳转到支付页面
  store.dispatch('system/toPlatform', {
    platform: 'payCtr',
    path: `/order/${payCode}`
  })
}

/**
 * 跳转到支付确认页面
 * @param skuId
 * @param data
 */
export function toPayCenterOrderConfirm(skuId, data) {
  const { payCode } = data
  if (payCode) {
    toPayCenter(payCode)
    return
  }

  store.dispatch('system/toPlatform', {
    platform: 'payCtr',
    path: '/order/confirm',
    query: Object.assign({}, data, { skuId })
  })
}

/**
 * 跳转到AI标书审查记录页面
 */
export function toAiCheckRecord(data) {
  store.dispatch('system/toPlatform', {
    platform: 'login',
    path: '/personal-center/value-added-services/ai-check'
  })
}

/**
 * 跳转到AI标书编写
 */
export function toAiBidCreate(data) {
  store.dispatch('system/toPlatform', {
    platform: 'login',
    path: '/personal-center/value-added-services/ai-check'
  })
}

/**
 * 字符串货币格式化
 * @param {string} numStr 数字字符串，可带小数
 */
export function strToThousands(numStr) {
  if (numStr == null || numStr == undefined) return numStr
  return numStr.toString().replace(/\d+/, function (n) {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      return $1 + ','
    })
  })
}

/**
 * 对象数组去重
 * @param {Array} arr 对象数组
 * @param {string} key 用于识别重复的属性名，默认使用'id'
 */
export function unique(arr, key = 'id') {
  const res = new Map()
  return arr.filter(
    (current) => !res.has(current[key]) && res.set(current[key], 1)
  )
}

/**
 * 将对象转换成页面路径传参的字符串
 * @param {Object} object
 * @returns {string}
 */
export function toStringOnPath(object) {
  if (!isObject(object)) return ''

  const stringArray = []
  for (const key in object) {
    stringArray.push(`${key}=${object[key]}`)
  }
  return stringArray.join('&')
}

/**
 * 解析字符串实现对象属性路径访问
 * @param {Object} obj 要访问的对象
 * @param {String} path 属性路径字符串
 * @returns {null|*} 对应的属性值
 */
export function getPropByPath(obj, path) {
  let tempObj = obj
  path = path?.replace(/\[(\w+)\]/g, '.$1')
  path = path?.replace(/^\./, '')

  const keyArr = path?.split('.') || []
  let i = 0
  for (let len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj) break
    const key = keyArr[i]
    if (key in tempObj) {
      tempObj = tempObj[key]
    } else {
      return null
      // break;
    }
  }
  return tempObj ? tempObj[keyArr[i]] : null
}

/**
 * 字符串按字数限制省略
 * @param {string} str 目标字符串
 * @param {number} size 限制显示的字数
 * @returns {string} 省略后的字符串
 */
export function stringEllipsis(str = '', size = 150) {
  if (str.length > size) {
    str = str.substring(0, size - 1) + '...'
  }
  return str
}

/**
 * 将query参数添加到url中 并 返回新的url，默认会携带上ac
 * @param oldUrl {String} 原url
 * @param queryObj {Object} 需要增加的query参数
 * @param needAC {Boolean} 是否需要自动携带ac
 * @return {String} 新url
 */
export function addQueryToUrl(oldUrl, queryObj = {}, needAC = true) {
  const whiteListConfig = {
    staticDomains: [],
    patternDomains: ['.jczh.com', 'yingcaicheng.net']
  }
  function isValidTarget(urlStr) {
    let url
    try {
      url = new URL(urlStr)
    } catch {
      return false
    }
    const hostname = url.hostname.toLowerCase()
    if (whiteListConfig.staticDomains.includes(hostname)) {
      return true
    }
    return whiteListConfig.patternDomains.some((domain) => {
      const d = domain.replace(/^\./, '').toLowerCase()
      return hostname === d || hostname.endsWith(`.${d}`)
    })
  }
  const ac = Cookies.get('X-JCZH-AC')
  queryObj = Object.assign(
    {},
    needAC && ac && isValidTarget(oldUrl) ? { 'x-jczh-ac': ac } : {},
    queryObj
  )
  if (!oldUrl || isEmpty(queryObj)) return oldUrl

  const tempUrl = oldUrl.split('#')[0] || ''
  const hashUrl = oldUrl.split('#')[1] || ''
  const mainUrl = tempUrl.split('?')[0] || ''
  const queryUrl = tempUrl.split('?')[1] || ''

  let queryUrlObj = {}
  queryUrl.split('&').forEach((value) => {
    if (!value) return

    const temp = value.split('=')
    queryUrlObj[temp[0]] = temp[1]
  })
  queryUrlObj = Object.assign({}, queryUrlObj, queryObj)

  const queryList = Object.keys(Object.assign({}, queryUrlObj, queryObj)).map(
    (key) => {
      return `${key}=${queryUrlObj[key]}`
    }
  )

  let newUrl = mainUrl
  if (queryList.length) {
    newUrl = `${newUrl}?${queryList.join('&')}`
  }
  if (hashUrl) newUrl = `${newUrl}#${hashUrl}`

  return newUrl
}

/**
 * 从主机名/URL中提取根域名，用于Cookie的domain属性
 * 例如：mall.jdzygcg.com -> .jdzygcg.com
 *      login.jdzygcg.com -> .jdzygcg.com
 *      jdzygcg.com -> .jdzygcg.com
 *      localhost -> localhost
 */
export const getCookieDomain = (hostname = window.location.hostname) => {
  // 移除端口号
  const host = String(hostname).replace(/:\d+$/, '')
  // 如果是localhost或IP地址，直接返回
  if (host === 'localhost' || /^(\d{1,3}\.){3}\d{1,3}$/.test(host)) {
    return host
  }

  // 定义特殊后缀（多级后缀）
  const specialSuffixes = ['com.cn', 'net.cn', 'org.cn', 'gov.cn', 'co.uk']
  const parts = host.split('.')

  // 从后往前尝试匹配特殊后缀
  for (let i = 1; i < parts.length; i++) {
    const possibleSuffix = parts.slice(i).join('.')
    if (specialSuffixes.includes(possibleSuffix)) {
      // 主域名为特殊后缀的前一段 + 该后缀
      return parts.slice(i - 1).join('.')
    }
  }

  // 取最后两部分作为根域名
  const rootDomain = parts.slice(-2).join('.')
  return `.${rootDomain}`
}

/**
 * 将数字按中文单位格式化，只有达到对应量级才转换
 * @param {number} num - 原始数字
 * @param {string[]} [allowedUnits] - 可选，允许转换的单位列表['十', '百', '千', '万', '十万', '百万', '千万', '亿']
 *   默认为万、亿：
 * @returns {string} 格式化后的字符串，如 "1千"、"3.5万"
 *
 * @example
 * formatNumberUnit(1000)               // "1千"
 * formatNumberUnit(500)                // "500"（不够千）
 * formatNumberUnit(15000)              // "1.5万"
 * formatNumberUnit(3500000)            // "350万"（不够千万）
 * formatNumberUnit(100000000)          // "1亿"
 * formatNumberUnit(15000, ['万', '亿']) // "1.5万"
 * formatNumberUnit(500, ['万', '亿'])  // "500"（不够万）
 */
export function formatNumberUnit(num, allowedUnits) {
  if (num === null || num === undefined || isNaN(num)) return ''
  if (num < 10) return String(num)

  const allUnits = [
    { unit: '十', value: 10 },
    { unit: '百', value: 100 },
    { unit: '千', value: 1000 },
    { unit: '万', value: 10000 },
    { unit: '十万', value: 100000 },
    { unit: '百万', value: 1000000 },
    { unit: '千万', value: 10000000 },
    { unit: '亿', value: 100000000 }
  ]

  const units = allowedUnits?.length
    ? allUnits.filter((u) => allowedUnits.includes(u.unit))
    : allUnits.filter((u) => u.unit === '万' || u.unit === '亿')

  // 从最大单位开始找，第一个 >= num 的单位就是最合适的
  for (let i = units.length - 1; i >= 0; i--) {
    if (num >= units[i].value) {
      const result = num / units[i].value
      // 整数直接返回，小数保留 1 位
      const formatted =
        result % 1 === 0 ? result : parseFloat(result.toFixed(1))
      return formatted + units[i].unit
    }
  }

  return String(num)
}
